export const ALIPAY_BLUESNAP_CONST: string = 'alipay';
export const BANKTRANSFER_BLUESNAP_CONST: string = 'banktransfer';
export const CC_BLUESNAP_CONST: string = 'cc';
export const ECP_BLUESNAP_CONST: string = 'ecp';
export const PAYSAFECARD_BLUESNAP_CONST: string = 'paysafecard';
export const REALTIMEBANK_BLUESNAP_CONST: string = 'realtimebank';
export const WIRE_BLUESNAP_CONST: string = 'wire';
export const US_BLUESNAP_CONST: string = 'US';
export const USD_BLUESNAP_CONST: string = 'USD';
export const CN_BLUESNAP_CONST: string = 'CN';
export const CNY_BLUESNAP_CONST: string = 'CNY';

export const BLUESNAP_PAYMENT_FLAG: string = 'isBluesnap';
export const STRIPE_PAYMENT_FLAG: string = 'isStripe';

export const ACH_STRIPE_CONST: string = 'us_bank_account';
